import React from 'react'
import './Card.css'

import Chevron from './Chevron.svg'
import ico from './shoppingbasket.svg'

const Card = ({number,text,notice,second_info,colorbottom,colortop}) => {
  return (
    <div className='HomeCard' style={{'--color1':colorbottom,'--color2':colortop}}>
        <div className='MainInfo'>
            <div className='MainInfo_Ico'>
                <img src={ico} alt="" srcset="" />
            </div>
            <div  className='MainInfo_Text'>
                <span className='numb'>{number}</span>
                <span className='text'>{text}</span>
                <span className='notice'>{notice}</span>
            </div>
        </div>
        <div className='SecondaryInfo'>
            <span className='SecondaryInfo_text'>
                {second_info}
            </span>
            <span className='SecondaryInfo_ico'>
                <img src={Chevron} alt="" srcset="" />
                
            </span>
        </div>  
    </div>
  )
}

export default Card